<template>
  <v-footer color="blue100" padless class="d-flex justify-center">
    <v-container v-if="$root.isDesktop" class="d-flex justify-center">
      <v-row class="white--text app-width-limit mt-1">
        <v-col cols="3" md="3" v-for="(info, i) of informations" :key="i">
          <div class="font-weight-bold">{{ t(info.title) }}</div>
          <div class="mt-3">
            <div style="cursor: pointer;" @click="openHref(item.href)" v-for="(item, j) of info.items" :key="j" >
              {{ item.noTraslate ? item.title : t(item.title) }}
            </div>
          </div>
        </v-col>
  <!--       <v-col cols="3" md="3">
          <div class="font-weight-bold">{{ t("social.title") }}</div>
          <v-row class="mt-3">
            <v-card
              class="ml-2"
              min-width="45px"
              min-height="45px"
              v-for="n of 3"
              :key="n"
            >
            </v-card>
          </v-row>
        </v-col> -->
        <v-col class="blue100 text-center white--text" cols="12">
          <span
            >&copy; {{ new Date().getFullYear() }} Shuttle Central. All rights
            reserved.</span
          >
        </v-col>
      </v-row>
    </v-container>
    <v-main v-else>
      <v-list-group color="white" v-for="(info, i) of informations" :key="i">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              t(info.title)
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-slot:appendIcon
          ><v-icon color="white">$expand</v-icon></template
        >
        <v-list-item
          class="white--text"
          v-for="(item, j) in info.items"
          :key="j"
          link
          @click="openHref(item.href)"
        >
          <v-list-item-title
            class="ml-3"
            v-text="item.noTraslate ? item.title : t(item.title)"
          ></v-list-item-title>
        </v-list-item>
      </v-list-group>
<!--       <v-container class="my-4">
        <v-row class="d-flex justify-center">
          <v-card
            class="ml-5"
            min-width="65px"
            min-height="65px"
            v-for="n of 3"
            :key="n"
          >
          </v-card>
        </v-row>
      </v-container> -->
      <v-container class="text-center mb-4">
        <span class="white--text"
          >&copy; {{ new Date().getFullYear() }} Shuttle Central. All rights
          reserved.</span
        >
      </v-container>
    </v-main>
  </v-footer>
</template>

<script>
export default {
  data: (vm) => ({
    links: ["Home", "About Us", "Team", "Services", "Blog", "Contact Us"],
    informations: [
      {
        title: "shuttlecentral.title",
        items: [
  /*         {
            title: "shuttlecentral.aboutUs",
            href: "#",
          }, */
          {
            title: "shuttlecentral.privacy",
            href: "https://shuttlecentral.com/aviso-de-privacidad",
          },
     /*      {
            title: "shuttlecentral.work",
            href: "#",
          }, */
        ],
      },
     /*  {
        title: "helpCenter.title",
        items: [
          {
            title: "helpCenter.howOperating",
            href: "#",
          },
          {
            title: "helpCenter.invoicing",
            href: "#",
          },
          {
            title: "helpCenter.questions",
            href: "#",
          },
        ],
      }, */
      {
        title: "contact.title",
        items: [
          {
            noTraslate: true,
            title: vm.$store.state.config.phoneNumber,
            href: "#",
          },
          {
            noTraslate: true,
            title: "alma@shuttlecentral.com",
            href: "#",
          },
        ],
      },
    ],
  }),
  methods: {
    t(key, options = {}) {
      return this.$t(`information.${key}`, options);
    },
    openHref(href){
      if(href) if(href !== '#') window.open(href, '_blank').focus();
    }
  },
};
</script>

<style></style>
